import { render } from "./OrderExtras.vue?vue&type=template&id=367641e2"
import script from "./OrderExtras.vue?vue&type=script&lang=ts"
export * from "./OrderExtras.vue?vue&type=script&lang=ts"

import "./OrderExtras.vue?vue&type=style&index=0&id=367641e2&lang=css"
script.render = render

export default script